import { render, staticRenderFns } from "./kanban-board.vue?vue&type=template&id=07ad8ef7&"
import script from "./kanban-board.vue?vue&type=script&lang=js&"
export * from "./kanban-board.vue?vue&type=script&lang=js&"
import style0 from "./kanban-board.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports